import { dateHelpers } from '@nocowanie/core';

import { LocationType } from '@app/enums';
import { environment } from '@app/environments/environment';
import { AccommodationItemModel, LocationDetailsModel, MarkerDataType } from '@app/models';

export interface SearchGuests {
    adultsCount: number;
    childrenCount: number;
    childrenAges: number[];
    guestCount: number;
}

export interface SearchCriteria {
    location: string;
    checkInDate: string | null;
    checkOutDate: string | null;
    guests: SearchGuests;
    geoId?: string | null;
    locationType?: LocationType | null;
    flexDates?: number;
    debug?: number;
    oneAlgorithm?: number;
    indexVersion?: number;
}

export interface SearchFilters {
    propertyType?: string[];
    amenities?: string[];
    rating?: number | null;
    priceFrom?: number | null;
    priceTo?: number | null;
    provision?: string[];
    reservationFeatures?: string[];
    // Legacy parameters for back navigation to listing page
    sort?: string | null;
    onlineBooking?: string | null;
}

export interface SearchState {
    searchCriteria: SearchCriteria;
    filters: SearchFilters;
    isFiltersContentVisible: boolean;
    isMapLoaded: boolean;
    meta: {
        isLoading: boolean;
        hasSearchChanged: boolean;
        hasGeoChanged: boolean;
        lastSearchTimestamp: number | null;
    };
    mapData: {
        accommodations?: MarkerDataType[];
        locationDetails: LocationDetailsModel | null;
        isLoadingAccommodations: boolean;
        accommodationsError: string | null;
        selectedAccommodation: AccommodationItemModel | null;
    };
}

export const defaultSearchCriteria: SearchCriteria = {
    location: '',
    checkInDate: dateHelpers.defaultCheckInDate().toISOString(),
    checkOutDate: dateHelpers.defaultCheckOutDate().toISOString(),
    guests: {
        adultsCount: 2,
        childrenCount: 0,
        childrenAges: [],
        guestCount: 2,
    },
    geoId: null,
    locationType: null,
    flexDates: environment.DEFAULT_FLEX_DATES,
};

export const defaultSearchFilters: SearchFilters = {
    rating: null,
    priceFrom: null,
    priceTo: null,
    propertyType: [],
    amenities: [],
    provision: [],
    reservationFeatures: [],
    sort: null,
    onlineBooking: null,
};

export const defaultMapData = {
    accommodations: undefined,
    locationDetails: null,
    isLoadingAccommodations: false,
    accommodationsError: null,
    selectedAccommodation: null,
};
